import { useEffect } from "react";

const AllPagesSignature = ({
  containerRef,
  label,
  dropX = 40,
  dropY = 100,
  setSignatureFields,
  setModePayload,
}) => {
  useEffect(() => {
    if (!containerRef?.current) return;

    const numPages = containerRef.current.children.length;
    const newFields = [];

    for (let pageIndex = 0; pageIndex < numPages; pageIndex++) {
      const pageContainer = containerRef.current.children[pageIndex];
      const textLayer = pageContainer.querySelector("div");
      if (!textLayer) continue;

      const fieldId = `${Date.now()}-${pageIndex}-${Math.random()}`;

      const wrapper = document.createElement("div");
      wrapper.style.position = "absolute";
      wrapper.style.left = `${dropX}px`;
      wrapper.style.top = `${dropY}px`;
      wrapper.style.cursor = "move";
      wrapper.style.display = "inline-flex";
      wrapper.style.alignItems = "center";

      const field = document.createElement("div");
      field.innerText = label;
      field.style.padding = "4px 8px";
      field.style.border = "1px solid #000";
      field.style.backgroundColor = "#f9f9f9";
      field.style.borderRadius = "4px";
      field.style.fontSize = "14px";
      field.style.fontFamily = "Arial";

      wrapper.appendChild(field);
      textLayer.appendChild(wrapper);

      newFields.push({
        id: fieldId,
        label,
        signatoryName: "",
        x: dropX,
        y: dropY,
        pageIndex,
        saved: true,
      });
    }

    // ✅ IMPORTANT: update state only once
    setSignatureFields((prev) => [...prev, ...newFields]);

    setModePayload(null);
  }, []);

  return null;
};

export default AllPagesSignature;
